angular
    .module('tradersyard')
    .factory('updatesService', [
        '$rootScope',
        '$socket',
        function ($rootScope, $socket) {
            var updatesService = {
                updatesEntry: '*', // '*' | 'webinar' | 'event' | 'group' | 'user' | 'topic';
                updatesQueue: [],
                updatesState: localStorage.getItem('graph:update-exists') !== null,
            };

            updatesService.appendUpdate = function (node) {
                var updateIdentities = updatesService.updatesQueue.map(function (item) {
                    return Number(item.id);
                });

                if (updateIdentities.indexOf(Number(node.id)) === -1) {
                    var updatesState = true;
                    updatesService.updatesQueue.unshift(node);
                    localStorage.setItem('graph:update-exists', '+');
                }
            };

            $rootScope.$on('appendUpdate', function (node) {
                updatesService.appendUpdate(node);
            });

            updatesService.cleanUpdates = function () {
                var _updatesQueue = updatesService.updatesQueue;
                updatesService.updatesQueue = [];
                updatesService.updatesState = false;
                localStorage.removeItem('graph:update-exists');
                return _updatesQueue;
            };

            $socket.on('post:create', function (message) {
                if ($rootScope.me && message.node.owner.id !== $rootScope.me.id) {
                    updatesService.updatesState = true;

                    if (!$rootScope.$$phase) $rootScope.$digest();
                }
            });

            return updatesService;
        },
    ])
    .controller('updatesController', [
        '$scope',
        'updatesService',
        function ($scope, $updates) {
            $scope.updates = $updates;
        },
    ]);
